import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Alert, AlertDescription } from "@/components/ui/alert";

// Success check icon component
const CheckCircleIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

export default function SuccessAlert() {
  const dispatch = useDispatch();
  const success = useSelector((state) => state.layout.success);

  useEffect(() => {
    if (success) {
      setTimeout(() => {
        dispatch({ type: "CLEAR_SUCCESS" });
      }, 2000);
    }
  }, [success, dispatch]);
  
  return success ? (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <Alert className="bg-green-600 border-green-600 text-white max-w-md mx-4">
        <CheckCircleIcon />
        <AlertDescription className="text-white font-bold text-xl text-center p-4">
          {success}
        </AlertDescription>
      </Alert>
    </div>
  ) : null;
}
